import CardDownloadDocument from 'components/CardDownloadDocument';
import HorizontalCard from 'components/HorizontalCard';
import Layout from 'Layout'
import React, { useState } from 'react'
import Imdoc from 'assets/images/im-doc.jpg'
import { useCallback } from 'react';
import { getDocumentById } from 'services/apiRoutes';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { saveAs } from "file-saver";
import SkeletonCardDocument from 'skeletons/SkeletonCardDocument';


export default function PostDocument() {
  const { slug,id } = useParams();
  const [doc,setDoc]= useState();

  const [loading,setLoading]=useState(false);

  const docAPI = useCallback(async(id) => {
    setLoading(true);
    const res = await getDocumentById(id,slug);
    if(res.error){
      return res.message
    }else{
      const {data} = res.data
      setDoc(data)
      setLoading(false)
    }
  },[slug])

  useEffect(() => {
    docAPI(id);
  }, [docAPI, id]);

  const handleClick = () => {
    if (!doc?.fileUrl && !doc?.url_dokumen) return;
    const url = doc?.fileUrl || doc?.url_dokumen;
    const link = document.createElement('a');
    link.href = url;
    link.download = doc?.nama || doc?.dokumen || 'dokumen';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Layout>
      <div className="items-center px-5 xl:pt-44 pt-28 Pencapaian-wrapper xl:px-99">
        <h1 className="text-2xl font-bold xl:mb-20 mb-14 xl:text-7xl">
          {doc?.nama}
        </h1>
        <div className="space-y-24 wrapperCad mb-[100px]">
          <HorizontalCard
            desc="Lihat data dan unduh"
            title="Dokumen Gampong"
            img={Imdoc}
          />
        </div>
        <div className="documentWrapper mb-[600px]">
          {loading ? (
            <SkeletonCardDocument />
          ) : (
              <CardDownloadDocument
                date={doc?.create_date?.substring(0, 10)}
                writer={doc?.list_kategori_dokumen_obj?.[0]?.kategori_obj?.nama || ""}
                title={doc?.nama}
                label={doc?.create_date?.substring(0, 10)}
                href={doc?.fileUrl || doc?.url_dokumen}
                fileName={doc?.nama || doc?.dokumen}
                onClick={handleClick}
              />
          )}
        </div>
      </div>
    </Layout>
  );
}

